'use client';
import { useState } from 'react';
import { useRouter } from 'next/navigation';

import { useTranslation } from 'src/i18n/client';
import useAppointments from 'src/hooks/useAppointments';
import Button from 'src/components/Button';
import ConfirmDialog from 'src/components/ConfirmDialog';

export default function AppointmentsPreview({ locale, appointment, expired }) {
    const { t } = useTranslation(locale, 'common');
    const router = useRouter();
    const { deleteAppointment } = useAppointments();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const handleDelete = async () => {
        try {
            await deleteAppointment(appointment?.code);
            await router.replace(`/programare/stearsa`);
        } catch {}
    };

    return (
        <>
            <section className="relative">
                <div className="container mx-auto">
                    <div className="m-auto grid h-96 content-center text-center md:w-2/3">
                        {expired && (
                            <div>
                                <h2 className="mb-3 text-6xl">{t('appointments.expired')}</h2>
                            </div>
                        )}

                        {!expired && (
                            <div className="flex flex-col gap-6">
                                <h2 className="mb-3 text-6xl">{t('appointments.deleteTitle')}</h2>
                                <p className="m-auto max-w-xl">{t('appointments.deleteInfo')}</p>

                                <div>
                                    <Button onClick={() => setDeleteModalOpen(true)} variant="primary" size="lg">
                                        {t('appointments.deleteButton')}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <ConfirmDialog
                title={t('appointments.deleteButton')}
                message={<p>{t('appointments.deleteContent')}</p>}
                buttonVariant="danger"
                open={deleteModalOpen}
                onNo={() => setDeleteModalOpen(false)}
                onYes={handleDelete}
            />
        </>
    );
}
